module.exports = __webpack_public_path__ + "img/The-Good-Logo.b57bd376.jpg";